import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface EmDocumentIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const EmDocumentIcon = ({ className, ...props }: EmDocumentIconProps) => (
  <svg
    className={cn(className)}
    fill="none"
    height="22"
    viewBox="0 0 22 22"
    width="22"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.0992 1.0639H2.88745V20.9069H19.1503V4.95L15.0992 1.0639Z"
      fill="white"
    />
    <path
      d="M5.73035 7.05548H16.2422"
      stroke="#B0BEC5"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="0.664262"
    />
    <path
      d="M5.73047 9.57001H16.2423"
      stroke="#B0BEC5"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="0.664262"
    />
    <path
      d="M5.73047 12.0828H16.2423"
      stroke="#B0BEC5"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="0.664262"
    />
    <path
      d="M5.73047 14.5974H16.2423"
      stroke="#B0BEC5"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="0.664262"
    />
    <path
      d="M5.73047 17.1119H10.225"
      stroke="#B0BEC5"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="0.664262"
    />
    <path
      d="M18.8117 4.05453L15.9483 1.1825C15.6114 0.864531 15.1663 0.6875 14.7022 0.6875H2.92877C2.66236 0.6875 2.4458 0.904062 2.4458 1.17047V20.8295C2.4458 21.0959 2.66236 21.3125 2.92877 21.3125H19.073C19.3394 21.3125 19.556 21.0959 19.556 20.8295V5.37625C19.5542 4.87609 19.1761 4.39828 18.8117 4.05453ZM18.8667 20.625H3.1333V1.375H14.2467C14.6111 1.375 14.9085 1.67063 14.9085 2.03672V5.10984H17.8888C18.4285 5.10984 18.8667 5.40719 18.8667 6.08781V20.625Z"
      fill="#6FBFF0"
    />
  </svg>
);

export default EmDocumentIcon;
